import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-675434f5")

_pushScopeId("data-v-675434f5")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2 -bold" }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "desktop",
  src: "/images/new/home.png"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "mobile",
  src: "/images/new/home_m.png"
}, null, -1)
const _hoisted_8 = { class: "intro" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_OnlineCareIntro = _resolveComponent("OnlineCareIntro")
  const _component_SecondOpinionIntro = _resolveComponent("SecondOpinionIntro")
  const _directive_scrollIcon = _resolveDirective("scrollIcon")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("figure", null, [
        _createVNode("div", null, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.t("home-intro-1")), 1),
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.t("home-intro-2")), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: _ctx.linkTo,
              class: "-bold"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t("take appointment")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        _hoisted_6,
        _hoisted_7
      ]),
      _createVNode("section", _hoisted_8, [
        _createVNode(_component_OnlineCareIntro, {
          class: "onlinecare-intro",
          linkPath: _ctx.RouterName.ONLINE_CARE
        }, null, 8, ["linkPath"]),
        _hoisted_9,
        _createVNode(_component_SecondOpinionIntro, {
          class: "secondopinion-intro",
          linkPath: _ctx.RouterName.SECOND_OPINION
        }, null, 8, ["linkPath"])
      ])
    ])
  ], 512)), [
    [_directive_scrollIcon]
  ])
})